import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Button from 'Common/components/Button';
import colors from 'Common/constants/colors';
import ConfirmModal
    from 'ProjectManager/Project/Preview/Timeline/PrimaryButtons/ArchiveButton/ConfirmModal';

const StyledButton = styled(Button)`
    background: ${colors.DARK_GRAY};

    &:hover,
    &.is-active {
        background: ${colors.SEARCH_FIELD_BORDER};
    }

    &[disabled] &:hover,
    &[disabled] &.is-active {
        background: ${colors.DARK_GRAY};
    }
`;

const ArchiveButton = props => {
    const [isModalOpened, setIsModalOpened] = useState(false);

    const handleClick = () => {
        setIsModalOpened(true);
    };

    const closeModal = () => {
        setIsModalOpened(false);
    };

    return (
        <>
            <StyledButton small type="button" onClick={handleClick} {...props}>
                Jetzt archivieren
            </StyledButton>
            {isModalOpened && <ConfirmModal onClose={closeModal} />}
        </>
    );
};

export default ArchiveButton;
